export default __webpack_public_path__ + "static/media/Website Terms and Conditions - Tapt By Hatch.b60ae65a.pdf";